<div class="container">
  <div class="flex flex-row justify-between items-center">
    <div class="title">{{ title | translate }}</div>

    <button
      *ngIf="showEditButton"
      gtm="onPreviousStep"
      gtmAction="Go to previous step"
      gtmCategory="gatewayCommissioning"
      mat-stroked-button
      data-at-back-button
      color="primary"
      [disabled]="gatewayCommissioningStore.transferInstallationLoading$ | async"
      [viConfirm]="viConfirmObject"
      (confirm)="confirm()"
      (click)="previousStepClicked()"
    >
      {{ 'GENERAL.BUTTON.EDIT' | translate }}
    </button>
  </div>
  <div class="description">{{ description | translate }}</div>
</div>
